import axiosInstance from 'api/axiosInstance';

export interface TagOption {
	Id: number;
	Title: string;
}

export const searchKeywords = async (keyword: string): Promise<TagOption[]> => {
	try {
		const { data } = await axiosInstance.get(
			`/api/cantrackv3/Keywords?Id=0&SearchKeyword=${encodeURIComponent(keyword)}&Page=1&Take=50&Ids=-1`,
		);
		return Array.isArray(data) ? data : data?.Data || [];
	} catch (error) {
		console.error('[searchKeywords] Failed:', error);
		throw error;
	}
};

export const searchReferences = async (keyword: string): Promise<TagOption[]> => {
	try {
		const { data } = await axiosInstance.get(
			`/api/cantrackv3/References?Id=0&SearchKeyword=${encodeURIComponent(keyword)}&Page=1&Take=50&Ids=-1`,
		);
		return Array.isArray(data) ? data : data?.Data || [];
	} catch (error) {
		console.error('[searchReferences] Failed:', error);
		throw error;
	}
};
